import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';
import creditChangeCheckService from '../../services/creditChangeCheckService';
import {
  GET_CREDIT_CHANGE_CHECK_REQUEST,
  GET_CREDIT_CHANGE_CHECK_SUCCESS,
  GET_CREDIT_CHANGE_CHECK_FAILURE,
  COMMON_FAILURE,
} from '../../actions';
import { historyType } from '../../../utils/commonType';

export type getCreditChangeCheckACtion = {
  type: typeof GET_CREDIT_CHANGE_CHECK_REQUEST;
  member_id: string;
  history: historyType;
};

function* getCreditChangeCheck(action: getCreditChangeCheckACtion): Generator<unknown> {
  try {
    const res: any = yield call(creditChangeCheckService(action).getCreditChangeCheck);
    yield put({
      type: GET_CREDIT_CHANGE_CHECK_SUCCESS,
      data: res.data,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_CREDIT_CHANGE_CHECK_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchGetCreditChangeCheck() {
  yield takeLatest(GET_CREDIT_CHANGE_CHECK_REQUEST, getCreditChangeCheck);
}
export default function* customerIdSaga(): Generator<unknown> {
  yield all([fork(watchGetCreditChangeCheck)]);
}
